var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#4A4A4A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,0.8c-2.9,0-5.3,2.4-5.3,5.3v10.5c0,2.9,2.4,5.3,5.3,5.3s5.3-2.4,5.3-5.3V6.1C21.3,3.2,18.9,0.8,16,0.8z  M19.1,16.6c0,1.7-1.4,3.1-3.1,3.1s-3.1-1.4-3.1-3.1V6.1C12.9,4.4,14.3,3,16,3s3.1,1.4,3.1,3.1V16.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 14.9,
    y: 25.1,
    className: "st0",
    width: 2.2,
    height: 5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.9,29h-5.8c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1.1,1.1,1.1h5.8c0.6,0,1.1-0.5,1.1-1.1S19.5,29,18.9,29z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.4,14.7c-0.6,0-1.1,0.5-1.1,1.1v0.9c0,4-3.3,7.3-7.3,7.3c-4,0-7.3-3.3-7.3-7.3v-0.9 c0-0.6-0.5-1.1-1.1-1.1s-1.1,0.5-1.1,1.1v0.9c0,5.2,4.3,9.5,9.5,9.5s9.5-4.3,9.5-9.5v-0.9C25.5,15.2,25,14.7,24.4,14.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetMic);
export default __webpack_public_path__ + "static/media/met-mic.3885b0d2b51fa9873bd1ecb54d212cb4.svg";
export { ForwardRef as ReactComponent };